import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import type { PatternTemplate, PatternTemplateRequest } from './Models';

const getPatternTemplate = async (
    departmentId: string,
    templateId: string,
): Promise<PatternTemplate> =>
    await dynoapeAPI.get(PATHS.patternTemplateById(departmentId, templateId));

/*
 * Failed requests throw (delete has no internal catch)
 * and leave the response untouched.
 */
const deletePatternTemplate = async (
    departmentId: string,
    templateId: string,
): Promise<PatternTemplate | boolean> =>
    (await dynoapeAPI.delete(
        PATHS.patternTemplateById(departmentId, templateId),
    )) ?? true;

/*
 * The endpoint always returns the updated template on success; a failed
 * update resolves undefined, so consumers distinguish failure from success
 * through the falsy response.
 */
const putPatternTemplate = async (
    departmentId: string,
    templateId: string,
    payload: PatternTemplateRequest,
): Promise<PatternTemplate> =>
    await dynoapeAPI.put(
        PATHS.patternTemplateById(departmentId, templateId),
        payload,
    );

const postPatternTemplate = async (
    departmentId: string,
    payload: PatternTemplateRequest,
): Promise<PatternTemplate> =>
    await dynoapeAPI.post(PATHS.patternTemplate(departmentId), payload);

const getPatternTemplates = async (
    departmentId: string,
): Promise<PatternTemplate[]> => {
    const response = await dynoapeAPI.get(PATHS.patternTemplates(departmentId));
    return response.elements;
};

const PatternTemplateService = {
    getPatternTemplate,
    deletePatternTemplate,
    putPatternTemplate,
    postPatternTemplate,
    getPatternTemplates,
};

export default PatternTemplateService;
